/* eslint-disable @typescript-eslint/no-explicit-any */

import { DocumentListingItem } from "./document-listing-item";
import { Fragment } from "react/jsx-runtime";

export const DocumentListing = ({ data, parentKey }: any) => {
  return (
    <Fragment>
      {Object.entries(data).map(([key, value], index: number) => {
        return (
          <Fragment key={key}>
            <DocumentListingItem
              parentKey={`${parentKey}.${key}`}
              data={value}
              // key={key}
              keyValue={key}
              isFirstRow={index === 0}
            />
          </Fragment>
        );
      })}
    </Fragment>
  );
};
